import type { ItemType, Modifier } from './backend';
import { enumIs } from './enums';
import { unreachable } from './unreachable';

export type ItemExtraStats = {
  damage: number;
  moveSpeed: number;
  armor: number;
  attackSpeed: number;
  health: number;
};

export function getItemStats(modifiers: Modifier[]): ItemExtraStats {
  const stats = {
    damage: 0,
    moveSpeed: 0,
    armor: 0,
    attackSpeed: 0,
    health: 0,
  };

  for (const mod of modifiers) {
    if (enumIs(mod, 'ExtraDamage')) {
      stats.damage += mod.ExtraDamage;
    } else if (enumIs(mod, 'ExtraArmor')) {
      stats.armor += mod.ExtraArmor;
    } else if (enumIs(mod, 'ExtraMoveSpeed')) {
      stats.moveSpeed += mod.ExtraMoveSpeed;
    } else if (enumIs(mod, 'ExtraHealth')) {
      stats.health += mod.ExtraHealth;
    } else {
      unreachable(mod);
    }
  }

  return stats;
}

export function getItemName(item: ItemType): string {
  if (enumIs(item, 'Armor')) {
    return 'Armor';
  } else if (enumIs(item, 'Boots')) {
    return 'Boots';
  } else if (enumIs(item, 'EnergyDrink')) {
    return 'Energy Drink';
  } else if (enumIs(item, 'Grenade')) {
    return 'Grenade';
  } else if (enumIs(item, 'Knife')) {
    return 'Knife';
  } else if (enumIs(item, 'MedKit')) {
    return 'MedKit';
  } else if (enumIs(item, 'Pistol')) {
    return 'Pistol';
  } else {
    unreachable(item);
  }
}
